<template>
    <div>
        <v-card flat>
            <v-toolbar color="#303a55" dark extended flat>
            </v-toolbar>
            <v-card class="mx-auto elevation-5" style="margin-top: -64px;" max-width="1000">
                <v-container class="pa-0">
                    <v-row>
                        <v-col cols="5" style="background-color: #1E88E5;" class="d-flex align-center justify-center">
                            <div>
                                <v-card-title class="white--text justify-center display-2">
                                    $1,500
                                </v-card-title>
                                <v-card-subtitle class="white--text text-center">
                                    Due amount for this month
                                </v-card-subtitle>
                            </div>
                        </v-col>
                        <v-col cols="7" class="justify-space-between d-flex">
                            <div class="d-flex align-center">
                                <VueApexCharts width="250" type="donut" :options="options" :series="series"></VueApexCharts>
                            </div>
                            <div>
                                <v-card width="300" class="mr-4" flat>
                                    <v-list color="#f0faff">
                                        <v-list-item>
                                            <v-list-item-content>
                                                <v-list-item-subtitle class="text-uppercase">
                                                    <span class="display-1 primary--text">3</span>
                                                    Payments made
                                                </v-list-item-subtitle>
                                            </v-list-item-content>
                                            <v-list-item-action>
                                                <small style="color: #139dff;">Total Amount</small>
                                                $1500
                                            </v-list-item-action>
                                        </v-list-item>
                                    </v-list>
                                </v-card>
                                <v-card width="300" class="mr-4 mt-2" flat>
                                    <v-list color="#f0faff">
                                        <v-list-item>
                                            <v-list-item-content>
                                                <v-list-item-subtitle class="text-uppercase">
                                                    <span class="display-1 warning--text">7</span> 
                                                    Due Payments
                                                </v-list-item-subtitle>
                                            </v-list-item-content>
                                            <v-list-item-action>
                                                <small style="color: #139dff;">Total Amount</small>
                                                $3000
                                            </v-list-item-action>
                                        </v-list-item>
                                    </v-list>
                                </v-card>
                            </div>
                        </v-col>
                    </v-row>
                </v-container>
            </v-card>
            <v-card max-width="1000" class="mx-auto mt-4" flat>
                <v-container class="pa-0">
                    <v-row>
                        <v-col cols="8">
                            <v-card class="elevation-4">
                                <v-card-title class="ml-4">
                                    <v-icon color="#139dff" class="mr-1">
                                        mdi-bookmark-outline
                                    </v-icon>
                                    Payment History
                                </v-card-title>
                                <v-container style="max-width: 600px;">
                                    <v-timeline dense clipped>
                                        <v-timeline-item fill-dot class="white--text mb-12" color="orange" large>
                                            <template v-slot:icon>
                                                <span>OCT</span>
                                            </template>
                                            <v-row>
                                                <v-col cols="12" class="black--text">
                                                    <small class="grey--text">Payable Amount: </small>
                                                    <span class="font-weight-bold" style="font-size: 20px;">$1500</span>
                                                    <br>
                                                    <v-btn color="primary" class="mt-4">Pay Now</v-btn>
                                                </v-col>
                                            </v-row>
                                        </v-timeline-item>
                                        <v-timeline-item class="mb-4" color="success" icon-color="grey lighten-1" small> 
                                            <v-row justify="space-between">
                                                <v-col cols="7">
                                                    <v-chip color="success" small>
                                                        <v-icon left small>mdi-arrow-up</v-icon>
                                                        Successfull
                                                    </v-chip>
                                                    $1500
                                                    <br>
                                                    <small>
                                                        18/10/2020 
                                                    </small>
                                                    <small class="ml-2">
                                                        |
                                                    </small>
                                                    <small class="ml-2">
                                                        TXN ID 12383743
                                                    </small>
                                                </v-col>
                                            </v-row>
                                        </v-timeline-item>
                                        <v-timeline-item class="mb-4" color="success" icon-color="grey lighten-2" small>
                                            <v-row justify="space-between">
                                                <v-col cols="7">
                                                    <v-chip color="success" small>
                                                        <v-icon left small>mdi-arrow-up</v-icon>
                                                        Successfull
                                                    </v-chip>
                                                    $1500
                                                    <br>
                                                    <small>
                                                        18/10/2020
                                                    </small>
                                                    <small class="ml-2">
                                                        |
                                                    </small>
                                                    <small class="ml-2">
                                                        TXN ID 12383743
                                                    </small>
                                                </v-col>
                                            </v-row>
                                        </v-timeline-item>
                                        <v-timeline-item class="mb-4" color="red" icon-color="grey lighten-2" small>
                                            <v-row justify="space-between">
                                                <v-col cols="7">
                                                    <v-chip color="error" small>
                                                        <v-icon left small>mdi-arrow-down</v-icon>
                                                        Declined
                                                    </v-chip>
                                                    $1500
                                                    <br>
                                                    <small>
                                                        18/10/2020  
                                                    </small>
                                                    <small class="ml-2">
                                                        |
                                                    </small>
                                                    <small class="ml-2">
                                                        TXN ID 12383743
                                                    </small>
                                                </v-col>
                                                <v-col class="text-right" cols="5">
                                                    <v-btn outlined small>Raise dispute</v-btn>
                                                </v-col>
                                            </v-row>
                                        </v-timeline-item>
                                        <v-timeline-item class="mb-4" color="success" icon-color="grey lighten-2" small>
                                            <v-row justify="space-between">
                                                <v-col cols="7">
                                                    <v-chip color="success" small>
                                                        <v-icon left small>mdi-arrow-up</v-icon>
                                                        Successfull
                                                    </v-chip>
                                                    $1500
                                                    <br>
                                                    <small>
                                                        18/10/2020 
                                                    </small>
                                                    <small class="ml-2">
                                                        |
                                                    </small>
                                                    <small class="ml-2">
                                                        TXN ID 12383743
                                                    </small>
                                                </v-col>
                                            </v-row>
                                        </v-timeline-item>
                                    </v-timeline>
                                </v-container>
                                
                            </v-card>
                        </v-col>
                        <v-col cols="4">
                            <v-card class="elevation-4">
                                <v-list>
                                    <v-list-item>
                                        <v-list-item-icon>
                                            <v-avatar size="56">
                                                <img src="https://cdn.pixabay.com/photo/2020/06/24/19/12/cabbage-5337431_1280.jpg" alt="">
                                            </v-avatar>
                                        </v-list-item-icon>
                                        <v-list-item-content>
                                            <v-list-item-title>Gitika khanna</v-list-item-title>
                                            <v-list-item-subtitle>DHA Course</v-list-item-subtitle>
                                        </v-list-item-content>
                                    </v-list-item>
                                </v-list>
                            </v-card>
                        </v-col>
                    </v-row>
                </v-container>
            </v-card>
        </v-card>
    </div>
</template>
<script>
    import VueApexCharts from 'vue-apexcharts'
    export default {
        data(){
            return{
                options:{
                    colors: ['#1A73E8', '#fb8c00'],
                    labels: ['Payments Made', 'Payments Due'],
                },
                series: [3, 7],
            }
        },
        components:{
            VueApexCharts
        }
    }
</script>

<style lang="scss" scoped>

</style>